import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { PRACTICE } from "../../lib/data";

export const WhatsAppFab = () => {
  const [show, setShow] = useState(false);
  const [tooltip, setTooltip] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 600);
    const t2 = setTimeout(() => setTooltip(false), 6000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-40 flex items-end gap-3">
      {tooltip && (
        <div className="hidden sm:flex items-center gap-2 bg-white border border-line shadow-lg rounded-full pl-4 pr-2 py-2 animate-in fade-in slide-in-from-right-3">
          <span className="text-sm text-ink font-medium">Chat with Dr. Venkat's team</span>
          <button
            aria-label="Dismiss tooltip"
            onClick={() => setTooltip(false)}
            data-testid="wa-tooltip-close"
            className="w-6 h-6 rounded-full bg-bone-2 hover:bg-line text-ink-soft flex items-center justify-center transition"
          >
            <X size={12} />
          </button>
        </div>
      )}

      <a
        href={`https://wa.me/${PRACTICE.whatsapp}?text=${encodeURIComponent(
          "Hi Dr. Venkat's team, I'd like to book a urology consultation."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab"
        className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-white shadow-xl hover:scale-105 transition"
        style={{ background: "#25D366" }}
      >
        <MessageCircle size={26} fill="currentColor" strokeWidth={0} />
        <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366] opacity-20" />
      </a>
    </div>
  );
};
